/* batida-personalizacja-v2.js — BS-32 Phase 2
 * <batida-personalizacja> UI controller for the server-rendered perso card.
 *
 * Scope: UI ONLY. The cart contract is owned by batida-drawer.js (collectMainItem +
 * collectCrossProducts read the DOM hooks the v2 snippet emits). The required-field
 * ATC guard + placeholders come from batida-napis-atc-sync.js, the digit grid from
 * batida-candle-picker.js, emoji-strip from batida-no-emoji.js — all KEPT, unchanged.
 *
 * This element only: toggle show/hide, sync the .cross-product__checkbox the drawer
 * reads, drive qty steppers, and swap the native Napis variant by reusing Pipeline's
 * own variant radios (so Pipeline's variant machinery updates the form id for us).
 */
(function () {
  if (window.__batidaPersoV2Loaded) return;
  window.__batidaPersoV2Loaded = true;

  function rowExpanded(row) {
    var e = row.nextElementSibling;
    return e && e.classList && e.classList.contains('batida-perso-expanded') ? e : null;
  }

  function setToggle(row, on) {
    var btn = row.querySelector('.batida-perso-toggle');
    var exp = rowExpanded(row);
    if (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on); // reuse existing .batida-perso-toggle.is-on CSS (knob slide + color)
    }
    if (exp) exp.hidden = !on;
    var cb = exp && exp.querySelector('.cross-product__checkbox');
    if (cb && cb.checked !== on) {
      cb.checked = on;
      try { cb.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
  }

  // Reuse Pipeline's variant selector: click the Napis option's TAK/NIE radio so the
  // theme recomputes + sets the form variant id (the '… / Tak' variant). No custom
  // variant math — single source of truth stays Pipeline.
  function napisRadio(yes) {
    var wraps = document.querySelectorAll('.selector-wrapper');
    // Radio values are localized (Tak/Yes/Oui/Ja/Так — Nie/No/Non/Nein/Ні), so match all.
    var sel = yes
      ? 'input[type=radio][value="TAK" i],input[type=radio][value="YES" i],input[type=radio][value="OUI" i],input[type=radio][value="JA" i],input[type=radio][value="ТАК" i]'
      : 'input[type=radio][value="NIE" i],input[type=radio][value="NO" i],input[type=radio][value="NON" i],input[type=radio][value="NEIN" i],input[type=radio][value="НІ" i]';
    // Ordered candidates, then use the FIRST wrapper that actually has the yes/no radio.
    // Robust for multi-option cakes (Kształt × Ilość porcji × Napis) where the option
    // position may not map 1:1 to .selector-wrapper indices.
    var candidates = [];
    var card = document.querySelector('batida-personalizacja[data-napis-position]');
    if (card) {
      var pos = parseInt(card.getAttribute('data-napis-position'), 10);
      if (pos && wraps[pos - 1]) candidates.push(wraps[pos - 1]); // position first (locale-independent)
    }
    for (var i = 0; i < wraps.length; i++) {
      var lbl = (wraps[i].getAttribute('data-select-label') || '').toLowerCase();
      // covers Napis / Napis* / Napis na torcie* / Tabliczka z napisem* + EN/UK/FR/DE labels
      if (/napis|nappis|inscription|tabliczka|beschriftung|inschrift|напис|writing/.test(lbl)) candidates.push(wraps[i]);
    }
    for (var j = 0; j < candidates.length; j++) {
      var r = candidates[j].querySelector(sel);
      if (r) {
        if (!r.checked) {
          // Click the LABEL, not the input: Pipeline updates the hidden variant id on the
          // label click; a bare input.click() can leave the id stale on translated stores.
          var lb = r.id ? candidates[j].querySelector('label[for="' + r.id + '"]') : null;
          if (lb) { lb.click(); } else { r.click(); }
        }
        return;
      }
    }
  }

  // 2.10.2026: "Napis na torcie" as an add-on product (snippet: data-napis-addon). Off = the text must not travel with the
  // cake (batida-drawer.js reads #batida-napis-text whenever it has a value), so it is set aside and comes back when the
  // switch goes on again. The add-on's hidden quantity follows the cake quantity of the form being submitted.
  function napisAddon(on) {
    var inp = document.getElementById('batida-napis-text');
    if (!inp) return;
    if (on) { if (!inp.value && inp.getAttribute('data-stash')) inp.value = inp.getAttribute('data-stash'); }
    else { inp.setAttribute('data-stash', inp.value || ''); inp.value = ''; }
    try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
  }
  function syncNapisQty(form) {
    var row = document.querySelector('.batida-perso-row[data-napis-addon]');
    var exp = row && rowExpanded(row);
    var q = exp && exp.querySelector('.cross-product__input');
    if (!q) return;
    var n = 1;
    try { n = parseInt(new FormData(form).get('quantity'), 10) || 1; } catch (e) {}
    q.value = String(Math.max(1, n));
  }
  document.addEventListener('submit', function (e) {   // capture on document = before batida-drawer.js (body, capture)
    var f = e.target;
    if (f && f.matches && f.matches('form[action$="/cart/add"]')) syncNapisQty(f);
  }, true);

  function onToggleClick(row) {
    var btn = row.querySelector('.batida-perso-toggle');
    if (!btn) return;
    var on = btn.getAttribute('aria-pressed') !== 'true';
    setToggle(row, on);
    if (row.hasAttribute('data-napis-addon')) napisAddon(on);
    else if (row.hasAttribute('data-napis-row')) napisRadio(on);
  }

  function onStep(input, dir) {
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var n = Math.max(min, (parseInt(input.value, 10) || min) + dir);
    input.value = n;
    var disp = input.parentElement && input.parentElement.querySelector('.batida-perso-stepper__display');
    if (disp) disp.textContent = n;
    try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }

  // v2 owns the perso area. custom.js's legacy perso builders are guarded off via
  // [data-perso-v2], but a legacy Liquid-rendered `.cross-products` source (+ its
  // duplicate napis/letter/candle inputs) can still be on the page during the
  // transition. Remove it once on connect — nothing rebuilds it (builders guarded),
  // so this is stable (no MutationObserver race). Becomes a no-op once the legacy
  // source render is removed from the theme in the final rollout step.
  function cleanupLegacy(card) {
    document.querySelectorAll('.cross-products').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.batida-addon-section').forEach(function (el) {
      if (!el.contains(card) && !el.querySelector('[data-perso-v2]')) el.remove();
    });
    ['#batida-napis-text', 'textarea[name="properties[_Message-Wiadomosc]"]', '.cross-product__input-text--candles', '.cross-product__checkbox'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { if (!el.closest('[data-perso-v2]')) el.remove(); });
    });
  }

  // The Napis row title/sub are static strings (Napis is a variant option, not a product,
  // so there's nothing for T Lab to localize). The addon rows + the Napis input placeholder
  // already localize (placeholder via batida-napis-atc-sync.js + window.batidaI18n); mirror
  // that JS-i18n pattern for the title/sub. Prefer a batidaI18n override if Caroline adds one.
  // BS-219 (2026-07-16): UK copy added (approved by Caroline); fr/de still fall back to EN.
  function localizeNapisLabel(card) {
    var row = card.querySelector('[data-napis-row]');
    if (!row) return;
    var I = window.batidaI18n || {};
    var lang = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
    var MAP = {
      pl: { t: 'Napis na torcie', s: 'Ręcznie pisany' },
      en: { t: 'Cake inscription', s: 'Handwritten' },
      uk: { t: 'Напис на торті', s: 'Написаний від руки' },
      // 6.10 (audit TRANS-03): de/fr = the strings of locales/de.json + fr.json (batida.napis.title / subtitle, du / tu)
      de: { t: 'Aufschrift auf der Torte', s: 'Handgeschrieben' },
      fr: { t: 'Inscription sur le gâteau', s: 'Écrit à la main' }
    };
    // any other language keeps the text the server rendered from the locale file (no more English fallback)
    var copy = MAP[lang];
    if (!copy && !I.napisTitle && !I.napisSub) return;
    copy = copy || {};
    var t = row.querySelector('.batida-perso-title');
    var s = row.querySelector('.batida-perso-sub');
    if (t && (I.napisTitle || copy.t)) t.textContent = I.napisTitle || copy.t;
    if (s && (I.napisSub || copy.s)) s.textContent = I.napisSub || copy.s;
  }

  function init(card) {
    if (card.__batidaWired) return;
    card.__batidaWired = true;
    cleanupLegacy(card);
    localizeNapisLabel(card);
    // The legacy Liquid `.cross-products` source can be rendered later in the DOM than
    // this element, so connect-time cleanup may run before it exists. Re-run a few times
    // (it's static — custom.js builders are guarded — so once removed it stays removed).
    [150, 500, 1200, 2500, 5000].forEach(function (ms) { setTimeout(function () { cleanupLegacy(card); }, ms); });
    card.addEventListener('click', function (e) {
      var tgl = e.target.closest && e.target.closest('.batida-perso-toggle');
      if (tgl) {
        var row = tgl.closest('.batida-perso-row');
        if (row) onToggleClick(row);
        return;
      }
      var step = e.target.closest && e.target.closest('.batida-perso-stepper__btn');
      if (step) {
        var wrap = step.closest('.batida-perso-stepper');
        var inp = wrap && wrap.querySelector('.cross-product__input');
        if (inp) onStep(inp, parseInt(step.getAttribute('data-step'), 10) || 0);
      }
    });
  }

  function boot() {
    try {
      if (window.customElements && !customElements.get('batida-personalizacja')) {
        customElements.define('batida-personalizacja', class extends HTMLElement {
          connectedCallback() { init(this); }
        });
        return;
      }
    } catch (e) {}
    // fallback: wire any existing nodes directly
    document.querySelectorAll('batida-personalizacja').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
